// CLARTEXT SPRACHE – Russisch (ru). Vollständige Übersetzung aller Keys
// (1:1-Key-Menge wie de.js/en.js, von Anfang an ohne Lücken — Juni 2026).
// Weltinhalte (Titel, Fragen, GBU-/BA-Texte) sind hier bewusst NICHT enthalten;
// sie kommen aus dem serverseitigen Translation-Worker.
const ru = {
  // Gemeinsame
  "common.loading": "Загрузка…",

  // PIN-Login (/monteur/login)
  "login.eyebrow": "Вход",
  "login.title": "Твой PIN",
  "login.subtitle": "Код фирмы + 4-значный PIN от твоего руководителя.",
  "login.companyCodeLabel": "Код фирмы",
  "login.companyCodePlaceholder": "напр. LUMPE",
  "login.submitting": "Выполняется вход…",
  "login.backAria": "Назад ко входу",
  "login.errorNoCode": "Сначала введи код фирмы.",
  "login.errorUnknown": "Фирма или PIN неизвестны.",

  // Aufgabenliste (/monteur)
  "tasks.companyFallback": "Ваше предприятие",
  "tasks.portalSubtitle": "Портал инструктажей",
  "tasks.loggedInAs": "Вы вошли как",
  "tasks.heading": "Твои задачи",
  "tasks.openCount": "{count} открыто",
  "tasks.emptyToday": "Сегодня нет открытых задач.",
  "tasks.newBanner": "У тебя {count} новых инструктажей с последнего визита.",
  "tasks.newBadge": "Новое",
  "tasks.newBannerDismissAria": "Закрыть уведомление",
  "tasks.backAria": "Назад к обзору",
  "home.tasksTitle": "Инструктажи",
  "home.searchTitle": "Справочник",
  "home.searchSubtitle": "Быстрый поиск информации по безопасности",
  "home.hspTitle": "План защиты кожи",
  "home.hspSubtitle": "Защита кожи и выбор перчаток в одном месте",
  "home.driverTitle": "Проверка водительского удостоверения",
  "home.driverOpen": "Пожалуйста, предъяви водительское удостоверение",
  "home.driverSubmitted": "Ожидает проверки предприятием",
  "home.driverUpToDate": "Действительно",
  "home.settingsTitle": "Настройки",
  "home.settingsSubtitle": "Управление e-mail и языком",
  "home.comingSoon": "Скоро будет доступно",
  "home.newBubbleAria": "{count} новых инструктажей",
  "settings.profileTitle": "Профиль",
  "settings.profileHint": "Имя и предприятие обновляются вашим предприятием.",
  "settings.emailTitle": "E-mail для уведомлений",
  "settings.emailPurpose": "Используется исключительно для информирования о новых инструктажах.",
  "settings.emailPlaceholder": "imya@primer.ru",
  "settings.emailSave": "Сохранить",
  "settings.emailSaved": "Сохранено",
  "settings.emailInvalid": "Введите действительный адрес e-mail.",
  "settings.emailRemoveHint": "Очистите поле и сохраните, чтобы отписаться от уведомлений.",
  "settings.saveError": "Не удалось сохранить. Попробуйте ещё раз.",
  "settings.privacyLink": "Политика конфиденциальности",
  "settings.consentLabel": "Я хочу получать уведомления о новых инструктажах по e-mail.",
  "settings.languageTitle": "Язык",
  "settings.langNotBooked": "Серые языки ещё не заказаны вашим предприятием. Обратитесь к своему руководителю, если хотите использовать один из них.",
  "tasks.quickLookup": "Быстрый поиск",
  "tasks.doneHeading": "Уже выполнено",
  "tasks.dueLabel": "Срок",
  "tasks.doneAtLabel": "Выполнено",
  "tasks.logoutAria": "Выйти",

  // Aushangpflicht-Anzeige (Mitarbeiter-Link + Seite)
  "aushang.linkTitle": "Законы и предписания, подлежащие обязательному вывешиванию",
  "aushang.linkSubtitle": "Официальные оригинальные тексты",
  "aushang.pageTitle": "Законы и предписания, подлежащие обязательному вывешиванию",
  "aushang.categoryAllgemein": "Общие законодательные основы",
  "aushang.categoryDguv": "Предписания DGUV и технические правила",

  // Aufgabendetail (/monteur/aufgabe/:id)
  "aufgabe.notFound": "Задача не найдена.",
  "aufgabe.wrongOne": "Один ответ был неверным. Ответь ещё раз.",
  "aufgabe.wrongMany":
    "{count} ответа(ов) были неверными. Ответь ещё раз.",
  "aufgabe.saveFailed": "Не удалось сохранить. Попробуй ещё раз.",
  "aufgabe.doneTitle": "Готово!",
  "aufgabe.doneBody":
    "Инструктаж «{title}» завершён. Твоё подтверждение создано автоматически и находится в контрольной папке твоего предприятия.",
  "aufgabe.backToTasks": "Назад к моим задачам",
  "aufgabe.stepContent": "Содержание",
  "aufgabe.stepQuestion": "Вопрос {current} из {total}",
  "aufgabe.backShort": "Задачи",
  "aufgabe.readCalm": "Пожалуйста, спокойно прочитай один раз.",
  "aufgabe.questionsFollow": "Затем последуют {count} коротких вопроса(ов) на понимание.",
  "aufgabe.questionLabel": "Вопрос на понимание {current} / {total}",
  "aufgabe.wrongAgain":
    "Этот ответ был неверным в прошлой попытке. Выбери ещё раз.",
  "aufgabe.prev": "Назад",
  "aufgabe.saving": "Сохранение…",
  "aufgabe.finish": "Завершить инструктаж",
  "aufgabe.toQuestions": "К вопросам",
  "aufgabe.next": "Далее",

  // Nachschlage-Suche (Komponente MonteurWeltSuche)
  "suche.placeholder": "Поиск – напр. «аккумулятор», «очки», «лестница»…",
  "suche.inputAria": "Поиск документационного мира",
  "suche.matchIn": "Совпадения в {label}:",
  "suche.empty": "Подходящий документационный мир не найден.",
  "suche.emptyHint": "Попробуй другое слово, напр. «СИЗ» или «повязка».",

  // Welt-Nachschlagewerk (/monteur/welt/:id) – NUR UI-Rahmen/Labels.
  "welt.headerTitle": "Справочник",
  "welt.backAria": "Назад",
  "welt.errorNotAvailable": "Этот документационный мир сейчас недоступен.",
  "welt.errorLoad": "Не удалось загрузить мир.",
  "welt.backToTasks": "Назад к моим задачам",
  "welt.loading": "Загрузка мира…",
  "welt.doctype": "Справочник",
  "welt.versionLabel": "Версия",
  "welt.gbuTitle": "Оценка рисков",
  "welt.noHazards": "Отдельные опасности не задокументированы.",
  "welt.residualRisk": "Остаточный риск:",
  "welt.measureTechnical": "Технические",
  "welt.measureOrganizational": "Организационные",
  "welt.measurePersonal": "Индивидуальные",
  "welt.responsible": "Ответственный:",
  "welt.baTitle": "Рабочая инструкция",
  "welt.baSubtitle": "Согласно TRBS / GefStoffV / BetrSichV",
  "welt.mainHazards": "Основные опасности",
  "welt.protectiveMeasures": "Меры защиты и правила поведения",
  "welt.emergency": "В экстренной ситуации",
  "welt.firstAid": "Первая помощь",
  "welt.disposalHazmat": "Хранение и утилизация",
  "welt.disposalVehicle": "Парковка",
  "welt.disposalDefault": "Вывод из эксплуатации",
  "welt.instructionTitle": "Инструктаж",
  "welt.instructionSubtitle": "Согласно DGUV V1 §4",
  "welt.visualTitle": "Визуальные учебные пособия",
  "welt.visualSubtitle":
    "Поддерживают понимание – не изменяют содержание, подтверждения и PDF",
  "welt.questionsTitle": "Вопросы на понимание",
  "welt.questionsSubtitle":
    "{count} вопросов — самопроверка, без отметки правильного ответа",
  "welt.maintenanceTitle": "Указания по проверке и обслуживанию",
  "welt.maintenanceSubtitle": "Согласно BetrSichV / UVV",
  "welt.performedBy": "Выполнение:",
  "welt.recommendedCheck": "Рекомендуемая проверка специалистом:",
  "welt.recurrenceTitle": "Циклы повторения",
  "welt.recurrenceSubtitle": "По модулям – автоматически контролируется системой",
  "welt.recurrenceUnterweisung": "Инструктаж",
  "welt.recurrenceGbuReview": "Оценка рисков – пересмотр",
  "welt.recurrenceWartung": "Обслуживание / проверка",
  "welt.recurrence.none": "–",
  "welt.recurrence.einmalig": "Однократно",
  "welt.recurrence.monatlich": "Ежемесячно",
  "welt.recurrence.vierteljaehrlich": "Ежеквартально",
  "welt.recurrence.halbjaehrlich": "Раз в полгода",
  "welt.recurrence.jaehrlich": "Ежегодно",
  "welt.recurrence.zwei_jahre": "Каждые 2 года",

  // Aufgaben-Status (StatusBadge)
  "status.offen": "Открыто",
  "status.erledigt": "Выполнено",
  "status.ueberfaellig": "Просрочено",

  // Feste Abschnitts-Überschriften der Unterweisungs-Inhalte (Anzeige-Lookup)
  "contentHeading.Worum geht es?": "О чём идёт речь?",
  "contentHeading.Welche Gefahren bestehen?": "Какие существуют опасности?",
  "contentHeading.Vor Arbeitsbeginn beachten": "Учитывать перед началом работы",
  "contentHeading.Während der Arbeit beachten": "Учитывать во время работы",
  "contentHeading.Nach der Arbeit beachten": "Учитывать после работы",

  // VLO-Präsentationslabels
  "vlo.safetySymbols.title": "Знаки безопасности",
  "vlo.safetySymbols.hint":
    "Эти знаки поддерживают инструктаж. Определяющим всегда является текст.",
  "vlo.psaSummary.title": "Сводка СИЗ",
  "vlo.hazardMarkers.title": "Обозначения опасностей",
  "vlo.learningFocus.title": "Фокус обучения",
  "vlo.richtigFalsch.title": "Правильно и неправильно",
  "vlo.richtigFalsch.correct": "Правильно",
  "vlo.richtigFalsch.wrong": "Неправильно",

  // Druck-/Plakat-Labels
  "plakat.eyebrow": "Плакат инструктажа",
  "plakat.subtitle": "Безопасная работа – важнейшие правила с первого взгляда",
  "plakat.symbols": "Знаки безопасности",
  "plakat.hazards": "Опасности",
  "plakat.richtigFalsch": "Правильно и неправильно",
  "plakat.correct": "Правильно",
  "plakat.wrong": "Неправильно",
  "plakat.psa": "Средства индивидуальной защиты (СИЗ)",
  "plakat.rules": "Важнейшие правила",
  "plakat.qrTitle": "Открыть мир напрямую",
  "plakat.qrText": "Отсканируй QR-код телефоном, введи PIN – документационный мир откроется сразу.",
  "plakat.footerHint": "Этот плакат поддерживает инструктаж. Определяющим остаётся полный инструктаж.",
  "plakat.moreInFull": "Дополнительные материалы в полном инструктаже",

  // Gruppen-Unterüberschriften + Mehrseitigkeit
  "plakat.hazardsSub": "Что может случиться?",
  "plakat.correctSub": "Так работают безопасно.",
  "plakat.wrongSub": "Так работать нельзя.",
  "plakat.continued": "Продолжение",
  "plakat.page": "Страница",

  // Gemeinsame UI-Chrome-Texte
  "common.back": "Назад",
  "common.notEnabled": "Этот раздел не активирован для вашего предприятия.",

  // Aushang-Bedienoberfläche (Gesetzestexte selbst bleiben amtlich deutsch)
  "aushang.kicker": "Обязательное вывешивание",
  "aushang.intro": "Ссылки на официальные оригинальные тексты. Оператор централизованно ведёт список; обновления проверяются перед принятием.",
  "aushang.loadError": "Не удалось загрузить раздел.",
  "aushang.listLoading": "Загрузка…",
  "aushang.listEmpty": "Записей пока нет — оператор ведёт список через консоль оператора.",
  "aushang.categoryEmpty": "В этой категории нет записей.",

  // Hautschutzplan-Ansicht (das Plakat selbst bleibt deutsch)
  "hsp.kicker": "План защиты рук",
  "hsp.titleFallback": "План защиты кожи и рук",
  "hsp.loadError": "Не удалось загрузить план защиты рук.",
  "hsp.empty": "Для этой зоны работ в настоящее время нет плана защиты рук.",
  "hsp.plakatCreatingTitle": "Плакат создаётся",
  "hsp.plakatCreatingText": "При первом открытии создаются изображения — это может занять до двух минут. После этого плакат доступен сразу.",
  "hsp.plakatFailedTitle": "Не удалось создать плакат.",
  "hsp.plakatFailedHint": "Пожалуйста, попробуйте ещё раз. Текстовый вид доступен ниже.",
  "hsp.plakatReload": "Плакат сейчас не удалось загрузить. Перезагрузите страницу.",
  "hsp.plakatTimeout": "Создание длится дольше ожидаемого. Попробуйте позже ещё раз.",
  "hsp.plakatRetry": "Не удалось создать плакат. Попробуйте ещё раз.",
  "hsp.plakatLoadFailed": "Плакат сейчас не удалось загрузить.",
  "hsp.plakatImgError": "Не удалось отобразить изображение плаката.",
  "hsp.plakatAlt": "Плакат плана защиты рук",
  "hsp.plakatLoadingAria": "Плакат загружается",
  "hsp.textOpen": "Показать как текст",
  "hsp.textClose": "Закрыть текстовый вид",
  "hsp.thWas": "Что",
  "hsp.thWann": "Когда",
  "hsp.thWomit": "Чем",
  "hsp.thWie": "Как",
  "hsp.firstAidTitle": "Первая помощь при контакте с кожей",
  "hsp.gsvOne": "1 опасное вещество в этой зоне",
  "hsp.gsvMany": "{count} опасных веществ в этой зоне",
  "hsp.gsvMenge": "Количество на предприятии:",
  "hsp.gsvHSaetze": "H-фразы:",
  "hsp.psaHandschutz": "Защита рук",
  "hsp.psaAtemschutz": "Защита органов дыхания",
  "hsp.psaAugenschutz": "Защита глаз",
  "hsp.psaKoerperschutz": "Защита тела",
  "hsp.psaErsteHilfe": "Первая помощь после контакта с кожей",
  "hsp.psaAetzReiz": "Разъедающее/раздражающее действие",
  "hsp.psaSensibilisierung": "Сенсибилизация",
  "hsp.psaPSaetze": "P-фразы",

  // Führerscheinkontrolle (Mitarbeiter)
  "fuehrerschein.title": "Проверка водительского удостоверения",
  "fuehrerschein.loadError": "Не удалось загрузить задачу.",
  "fuehrerschein.notApplicable": "Для вас в настоящее время проверка водительского удостоверения не предусмотрена.",
  "fuehrerschein.categoriesTitle": "Ваши виды транспортных средств",
  "fuehrerschein.categoriesSubtitle": "Эти виды транспортных средств определил для вас ваш работодатель.",
  "fuehrerschein.categoriesEmpty": "Категории не назначены.",
  "fuehrerschein.upToDateTitle": "Водительское удостоверение действительно",
  "fuehrerschein.upToDateText": "В настоящий момент проверка не требуется.",
  "fuehrerschein.nextDue": "Следующая проверка до",
  "fuehrerschein.lastDecision": "Последнее одобрение:",
  "fuehrerschein.submittedTitle": "Отправка успешна",
  "fuehrerschein.submittedText": "Фото вашего водительского удостоверения и декларация теперь на проверке у работодателя.",
  "fuehrerschein.submittedAt": "Отправлено",
  "fuehrerschein.declarationTitle": "Декларация",
  "fuehrerschein.declarationAccept": "Я прочитал(а) декларацию и подтверждаю её.",
  "fuehrerschein.photoFrontTitle": "Фото водительского удостоверения: лицевая сторона",
  "fuehrerschein.photoFrontHint": "Сфотографируйте лицевую сторону вашего водительского удостоверения хорошо читаемо (имя и дата окончания срока видны).",
  "fuehrerschein.photoBackTitle": "Фото водительского удостоверения: обратная сторона",
  "fuehrerschein.photoBackHint": "Сфотографируйте обратную сторону вашего водительского удостоверения хорошо читаемо (таблица категорий видна).",
  "fuehrerschein.previewFrontAlt": "Предпросмотр – лицевая сторона удостоверения",
  "fuehrerschein.previewBackAlt": "Предпросмотр – обратная сторона удостоверения",
  "fuehrerschein.otherPhoto": "Другое фото",
  "fuehrerschein.remove": "Удалить",
  "fuehrerschein.pickFront": "Снять лицевую сторону или выбрать файл",
  "fuehrerschein.pickBack": "Снять обратную сторону или выбрать файл",
  "fuehrerschein.pickLimits": "Макс. 12 МБ · JPEG, PNG, WEBP, HEIC",
  "fuehrerschein.submit": "Отправить",
  "fuehrerschein.submitting": "Отправка…",
  "fuehrerschein.submitSuccess": "Отправка успешна.",
  "fuehrerschein.submitFailed": "Отправка не удалась. Попробуйте ещё раз.",
  "fuehrerschein.errFormat": "Неподдерживаемый формат изображения. Выберите JPEG, PNG, WEBP, HEIC или HEIF.",
  "fuehrerschein.errSize": "Файл слишком большой. Максимум: 12 МБ.",
  "fuehrerschein.ocrPreparing": "Автоматическая помощь при чтении готовится…",
  "fuehrerschein.ocrUnavailable": "OCR временно недоступен — проверьте водительское удостоверение вручную.",
  "fuehrerschein.ocrBannerStrong": "Автоматическая расшифровка",
  "fuehrerschein.ocrBannerRest": " — не является проверкой со стороны CLartext, не заменяет визуальную проверку.",
  "fuehrerschein.ocrName": "Имя (считано)",
  "fuehrerschein.ocrExpiry": "Дата окончания срока (считано)",
  "fuehrerschein.ocrClasses": "Категории (считано)",
};

export default ru;
